export const arrow_left = {
	name: 'arrow-left',
	title: 'Arrow Left',
	content:
		'<path d="M 16.25,23.25L5.53,12.53c-0.293-0.292-0.293-0.767-0.001-1.059c0,0,0.001-0.001,0.001-0.001L16.25,0.75" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>',
};
